package com.jingfangpai.syndrome.model

import com.jingfangpai.common.orm.mapping.Syndrome
import kotlinx.serialization.Serializable

@Serializable
class SyndromeDetail:Syndrome() {
    var indications:Array<SyndromeIndicationDetail> = arrayOf()
}